module.exports = __webpack_public_path__ + "static/media/ps.07005a7f.svg";